import { BaseClient } from '@/api'
import request from '@/utils/request'

export class UserClient extends BaseClient {
  constructor(
  ) {
    super('users')
  }

  async password(data:{oldpassword:string, newpassword:string}): Promise<any> {
    return request({
      url: `/${this.path}/password`,
      method: 'put',
      data
    })
  }
}
